import {
  ApplicationConfig,
  provideBrowserGlobalErrorListeners,
  provideZonelessChangeDetection,
} from '@angular/core';
import { provideRouter } from '@angular/router';
import { providePrimeNG } from 'primeng/config';
import { routes } from './app.routes';
import {
  provideClientHydration,
  withEventReplay,
} from '@angular/platform-browser';
import customPreset from '../assets/primeng/customPreset';
import { provideLottieOptions } from 'ngx-lottie';
import player from 'lottie-web';
import { provideToastr } from 'ngx-toastr';
import { provideAnimations } from '@angular/platform-browser/animations';
import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptors,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { BaseInterceptor } from './core/interceptors/base-interceptor';
import { provideTranslateService } from '@ngx-translate/core';
import { provideLocalizationLoader } from './core/services/translate-service/translate-loader';
import { Language } from './shared/enums/language.enum';
import { errorInterceptor } from './core/interceptors/error-interceptor';
import { otpTokenInterceptor } from './core/interceptors/otp-token.interceptor';
import { hmacInterceptor } from './core/interceptors/hmac.interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZonelessChangeDetection(),
    provideClientHydration(),
    provideRouter(routes),
    provideClientHydration(withEventReplay()),
    provideHttpClient(
      withInterceptorsFromDi(),
      withInterceptors([hmacInterceptor, otpTokenInterceptor, errorInterceptor])
    ),
    providePrimeNG({
      theme: {
        preset: customPreset,
        options: {
          darkModeSelector: false,
        },
      },
    }),
    { provide: HTTP_INTERCEPTORS, useClass: BaseInterceptor, multi: true },
    provideLottieOptions({
      player: () => player,
    }),
    provideAnimations(),
    provideToastr({
      positionClass: 'toast-bottom-center',
      timeOut: 2000,
    }),
    provideTranslateService({
      lang: localStorage.getItem('lang') || Language.EN,
      fallbackLang: Language.EN,
      loader: provideLocalizationLoader(),
    }),
  ],
};
